module.exports = __webpack_public_path__ + "img/09-osm-outros-dept-lista.79002871.png";